export const milestoneOptions = {
  key1: [
    { key: 1, text: 'PI & Manual Cleaning', value: 'PI & Manual Cleaning' },
    { key: 2, text: 'Categorization', value: 'Categorization' },
    { key: 3, text: 'Repair', value: 'Repair' },
    {
      key: 4,
      text: 'Photo Chemical Restoration',
      value: 'Photo Chemical Restoration',
    },
    { key: 5, text: 'Ultra Sonic Cleaning', value: 'Ultra Sonic Cleaning' },
  ],
};
export const milestone = [
  { key: 1, text: 'Physical Inspection', value: 'Physical Inspection' },
  { key: 2, text: 'Digitilization', value: 'Digitilization' },
  { key: 3, text: 'Restoration', value: 'Restoration' },
  { key: 4, text: 'Review', value: 'Review' },
  { key: 5, text: 'Archive', value: 'Archive' },
  { key: 6, text: 'Access', value: 'Access' },
];
export const communicationSettings = [
  { key: 1, text: 'Start', value: 'start' },
  { key: 2, text: 'Complete', value: 'complete' },
  { key: 3, text: 'Hold', value: 'hold' },
  { key: 4, text: 'Resume', value: 'resume' },
  { key: 5, text: 'Reject', value: 'reject' },
  { key: 6, text: 'Rework', value: 'rework' },
  { key: 7, text: 'Resolve', value: 'resolve' },
];
export const ApiSetting = [
  { key: 1, text: 'Start', value: 'start' },
  { key: 2, text: 'Complete', value: 'complete' },
  { key: 3, text: 'Hold', value: 'hold' },
  { key: 4, text: 'Resume', value: 'resume' },
  { key: 5, text: 'Reject', value: 'reject' },
  { key: 6, text: 'Rework', value: 'rework' },
  { key: 7, text: 'Resolve', value: 'resolve' },
  { key: 8, text: 'V1', value: 'v1' },
  { key: 9, text: 'V2', value: 'v2' },
  { key: 10, text: 'V3', value: 'v3' },
];
export const Role = [
  { key: 1, text: 'Owner', value: 'Owner' },
  { key: 2, text: 'Borrower', value: 'Borrower' },
];
export const Attachment = [{ key: 1, text: 'PI Report', value: 'PI Report' }];
export const CommunicationAssignOptions = [
  {
    communicationassign: 'Tape',
    communicationarr: [
      {
        name: 'Template 1',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Film/Audio',
    communicationarr: [
      {
        name: 'Assets',

        mile: [
          {
            text: 'Filters',
            field: [
              {
                texts: 'All Assets',
              },
              {
                texts: 'Assets Scheduled For Cleaning',
              },
              {
                texts: 'Pending Returns From Borrowers',
              },
              {
                texts: 'Assets Cleaned',
              },
              {
                texts: 'New Asset Added',
              },
              {
                texts: 'Current Month Asset CAN Movement',
              },
            ],
          },
          {
            text: 'Calendar ',
            field: [
              {
                texts: 'Option 1',
              },
            ],
          },
          {
            text: 'Assets',
            field: [
              {
                texts: 'Asset Video',
              },
              {
                texts: 'Inventory',
              },
              {
                texts: 'User',
              },
              {
                texts: 'Chat',
              },
              {
                texts: 'MetaData',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Film/Picture',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Photo',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Document',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
];
export const templateOptions = [
  {
    communicationassign: 'Template 1',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Template 2',
    communicationarr: [
      {
        name: 'Assets',

        mile: [
          {
            text: 'Filters',
            field: [
              {
                texts: 'All Assets',
              },
              {
                texts: 'Assets Scheduled For Cleaning',
              },
              {
                texts: 'Pending Returns From Borrowers',
              },
              {
                texts: 'Assets Cleaned',
              },
              {
                texts: 'New Asset Added',
              },
              {
                texts: 'Current Month Asset CAN Movement',
              },
            ],
          },
          {
            text: 'Calendar ',
            field: [
              {
                texts: 'Option 1',
              },
            ],
          },
          {
            text: 'Assets',
            field: [
              {
                texts: 'Asset Video',
              },
              {
                texts: 'Inventory',
              },
              {
                texts: 'User',
              },
              {
                texts: 'Chat',
              },
              {
                texts: 'MetaData',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Template 3',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Template 4',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    communicationassign: 'Template 5',
    communicationarr: [
      {
        name: 'Home',
        mile: [
          {
            text: 'Inventory',
            field: [
              {
                texts: 'Inventory Table',
              },
              {
                texts: 'Inventory Form',
              },
            ],
          },
          {
            text: 'Orders',
            field: [
              {
                texts: 'Order Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
          {
            text: 'Production Planning',
            field: [
              {
                texts: 'Production Table',
              },
              {
                texts: 'Report Graphics',
              },
            ],
          },
        ],
      },
    ],
  },
];

export const modalMileStoneOptions = [
  {
    name: 'Physical Inspection',
    text: 'Physical Inspection',
    value: 'Physical Inspection',
    Icon: 'barcode',
    mile: [
      {
        text: 'PI & Manual Cleaning',
        value: 'PI & Manual Cleaning',
        field: [
          {
            texts: 'Length In Ft',
            text: 'Length In Ft',
            value: 'Length In Ft',
          },
          {
            texts: 'Elements',
            text: 'Elements',
            value: 'Elements',
            options: [
              {
                text: 'Camera Negative (PN)',
                value: 'Camera Negative (PN)',
              },
              { text: 'Positive Print', value: 'Positive Print' },
              {
                text: 'Sound Negative (SN)',
                value: 'Sound Negative (SN)',
              },
              {
                text: 'Sound Positive(RP)',
                value: 'Sound Positive(RP)',
              },
              {
                text: 'IN-Dupe Neg(IN)',
                value: 'IN-Dupe Neg(IN)',
              },
              {
                text: 'IP-Dupe Pos(MP)',
                value: 'IP-Dupe Pos(MP)',
              },
              {
                text: 'Reversal Neg(Intermediate)',
                value: 'Reversal Neg (Intermediate)',
              },
              { text: 'Reversal Pos', value: 'Reversal Pos' },
              { text: 'Overlay', value: 'Overlay' },
              { text: 'Other', value: 'Other' },
            ],
          },
          {
            texts: 'Reel/Can Size',
            text: 'Reel/Can Size',
            value: 'Reel/Can Size',
            options: [
              { text: 'Reel 1', value: 'Reel 1' },
              { text: 'Reel 2', value: 'Reel 2' },
              { text: 'Reel 3', value: 'Reel 3' },
              { text: 'Reel 4', value: 'Reel 4' },
              { text: 'Reel 5', value: 'Reel 5' },
              { text: 'Reel 6', value: 'Reel 6' },
              { text: 'Reel 7', value: 'Reel 7' },
              { text: 'Reel 8', value: 'Reel 8' },
              { text: 'Reel 9', value: 'Reel 9' },
              { text: 'Reel 10', value: 'Reel 10' },
            ],
          },
          {
            texts: 'Film Gauge',
            text: 'Film Gauge',
            value: 'Film Gauge',
            options: [
              { text: '35MM', value: '35MM' },
              { text: '16MM', value: '16MM' },
              { text: '8MM', value: '8MM' },
              { text: '70MM', value: '70MM' },
              { text: 'Super 16MM', value: 'Super 16MM' },
              { text: 'Super 8MM', value: 'Super 8MM' },
              { text: 'Others', value: 'Others' },
            ],
          },
          {
            texts: 'Film Base',
            text: 'Film Base',
            value: 'Film Base',
            options: [
              { text: 'Acetate', value: 'Acetate' },
              { text: 'Polyster', value: 'Polyster' },
              { text: 'Nitrate', value: 'Nitrate' },
            ],
          },
          {
            texts: 'Colour',
            text: 'Colour',
            value: 'Colour',
            options: [
              { key: 'Colour', text: 'Colour', value: 'Colour' },
              { key: 'B&W', text: 'B&W', value: 'B&W' },
              { key: 'Tinted', text: 'Tinted', value: 'Tinted' },
              { key: 'Toned', text: 'Toned', value: 'Toned' },
              {
                key: 'Stencil',
                text: 'Stencil',
                value: 'Stencil',
              },
            ],
          },
          {
            texts: 'Stock/Brand',
            text: 'Stock/Brand',
            value: 'Stock/Brand',
            options: [
              { key: 'Kodak', text: 'Kodak', value: 'Kodak' },
              { key: 'fuji', text: 'fuji', value: 'fuji' },
              {
                key: 'Agfa/Gevaert',
                text: 'Agfa/Gevaert',
                value: 'Agfa/Gevaert',
              },
              { key: 'Orwo', text: 'Orwo', value: 'Orwo' },
              { key: 'Indu', text: 'Indu', value: 'Indu' },
              { key: 'Other', text: 'Other', value: 'Other' },
            ],
          },
          {
            texts: 'Image Format',
            text: 'Image Format',
            value: 'Image Format',
            options: [
              { key: '1:1,33', text: '1:1,33', value: '1:1,33' },
              { key: '1:1,37', text: '1:1,37', value: '1:1,37' },
              { key: '1:1,66', text: '1:1,66', value: '1:1,66' },
              { key: '1:1,78', text: '1:1,78', value: '1:1,78' },
              { key: '1:1,85', text: '1:1,85', value: '1:1,85' },
              { key: '1:2,35', text: '1:2,35', value: '1:2,35' },
              { key: '1:2,2', text: '1:2,2', value: '1:2,2' },
              { key: '1:1,19', text: '1:1,19', value: '1:1,19' },
              { key: '1:1,43', text: '1:1,43', value: '1:1,43' },
            ],
          },
          {
            texts: 'Sound Format',
            text: 'Sound Format',
            value: 'Sound Format',
            options: [
              {
                key: 'Optical Variable Area',
                text: 'Optical Variable Area',
                value: 'Optical Variable Area',
              },
              {
                key: 'Optical Variable Density',
                text: 'Optical Variable Density',
                value: 'Optical Variable Density',
              },
              {
                key: 'Magnetic',
                text: 'Magnetic',
                value: 'Magnetic',
              },
              {
                key: 'Dolby SR',
                text: 'Dolby SR',
                value: 'Dolby SR',
              },
              {
                key: 'Dolby Digital',
                text: 'Dolby Digital',
                value: 'Dolby Digital',
              },
              {
                key: 'No of Tracks',
                text: 'No of Tracks',
                value: 'No of Tracks',
              },
            ],
          },
          {
            texts: 'Dolby Digital',
            text: 'Dolby Digital',
            value: 'Dolby Digital',
            options: [
              { key: 'DTS', text: 'DTS', value: 'DTS' },
              { key: 'DTS CD', text: 'DTS CD', value: 'DTS CD' },
            ],
          },
          {
            texts: 'Preservation Condition',
            text: 'Preservation Condition',
            value: 'Preservation Condition',
            options: [
              { key: 'A', text: 'A', value: 'A' },
              { key: 'B', text: 'B', value: 'B' },
              { key: 'C', text: 'C', value: 'C' },
            ],
          },
          {
            texts: 'Film Status',
            text: 'Film Status',
            value: 'Film Status',
            options: [
              {
                key: 'Brittle',
                text: 'Brittle',
                value: 'Brittle',
              },
              { key: 'Soft', text: 'Soft', value: 'Soft' },
              {
                key: 'Buckle & Weave',
                text: 'Buckle & Weave',
                value: 'Buckle & Weave',
              },
              {
                key: 'Low Thickness',
                text: 'Low Thickness',
                value: 'Low Thickness',
              },
              {
                key: 'Emulsion Loss',
                text: 'Emulsion Loss',
                value: 'Emulsion Loss',
              },
              {
                key: 'Crystals/Exudation',
                text: 'Crystals/Exudation',
                value: 'Crystals/Exudation',
              },
              {
                key: 'High Stickness',
                text: 'High Stickness',
                value: 'High Stickness',
              },
              {
                key: 'Dye Fade',
                text: 'Dye Fade',
                value: 'Dye Fade',
              },
              {
                key: 'Mould/Fungus',
                text: 'Mould/Fungus',
                value: 'Mould/Fungus',
              },
              {
                key: 'Blocked',
                text: 'Blocked',
                value: 'Blocked',
              },
              {
                key: 'Ferro Type',
                text: 'Ferro Type',
                value: 'Ferro Type',
              },
              {
                key: 'Delamination',
                text: 'Delamination',
                value: 'Delamination',
              },
              { key: 'None', text: 'None', value: 'None' },
            ],
          },
          {
            texts: 'Film Status Scale',
            text: 'Film Status Scale',
            value: 'Film Status Scale',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              { key: 'Minor', text: 'Minor', value: 'Minor' },
              { key: 'Medium', text: 'Medium', value: 'Medium' },
              { key: 'Major', text: 'Major', value: 'Major' },
            ],
          },
          {
            texts: 'Foreign Matters',
            text: 'Foreign Matters',
            value: 'Foreign Matters',
            options: [
              {
                key: 'Dust/Dirt',
                text: 'Dust/Dirt',
                value: 'Dust/Dirt',
              },
              {
                key: 'Grease/Oil',
                text: 'Grease/Oil',
                value: 'Grease/Oil',
              },
              {
                key: 'Rust Stains',
                text: 'Rust Stains',
                value: 'Rust Stains',
              },
              { key: 'None', text: 'None', value: 'None' },
              {
                key: 'Adhesive Residue',
                text: 'Adhesive Residue',
                value: 'Adhesive Residue',
              },
            ],
          },
          {
            texts: 'Physical Damage',
            text: 'Physical Damage',
            value: 'Physical Damage',
            options: [
              {
                key: 'Sprocket Damage',
                text: 'Sprocket Damage',
                value: 'Sprocket Damage',
              },
              {
                key: 'Open/Weak Splices',
                text: 'Open/Weak Splices',
                value: 'Open/Weak Splices',
              },
              {
                key: 'Broken Splice',
                text: 'Broken Splice',
                value: 'Broken Splice',
              },
              { key: 'None', text: 'None', value: 'None' },
              { key: 'Folds', text: 'Folds', value: 'Folds' },
              {
                key: 'Broken Perforation',
                text: 'Broken Perforation',
                value: 'Broken Perforation',
              },
              { key: 'Tears', text: 'Tears', value: 'Tears' },
              {
                key: 'Film/Image Burnt',
                text: 'Film/Image Burnt',
                value: 'Film/Image Burnt',
              },
            ],
          },
          {
            texts: 'Emulsion Scratches',
            text: 'Emulsion Scratches',
            value: 'Emulsion Scratches',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              {
                key: 'Vertical',
                text: 'Vertical',
                value: 'Vertical',
              },
              {
                key: 'Horizontal Intermittent',
                text: 'Horizontal Intermittent',
                value: 'Horizontal Intermittent',
              },
              {
                key: 'Horizontal Continuous',
                text: 'Horizontal Continuous',
                value: 'Horizontal Continuous',
              },
            ],
          },
          {
            texts: 'Emulsion Scratches Scale',
            text: 'Emulsion Scratches Scale',
            value: 'Emulsion Scratches Scale',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              { key: 'Low', text: 'Low', value: 'Low' },
              {
                key: 'Moderate',
                text: 'Moderate',
                value: 'Moderate',
              },
              { key: 'Medium', text: 'Medium', value: 'Medium' },
              { key: 'High', text: 'High', value: 'High' },
              {
                key: 'Very High',
                text: 'Very High',
                value: 'Very High',
              },
            ],
          },
          {
            texts: 'Base Scratches',
            text: 'Base Scratches',
            value: 'Base Scratches',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              {
                key: 'Vertical',
                text: 'Vertical',
                value: 'Vertical',
              },
              {
                key: 'Horizontal Intermittent',
                text: 'Horizontal Intermittent',
                value: 'Horizontal Intermittent',
              },
              {
                key: 'Horizontal Continuous',
                text: 'Horizontal Continuous',
                value: 'Horizontal Continuous',
              },
            ],
          },
          {
            texts: 'Base Scratches Scale',
            text: 'Base Scratches Scale',
            value: 'Base Scratches Scale',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              { key: 'Low', text: 'Low', value: 'Low' },
              {
                key: 'Moderate',
                text: 'Moderate',
                value: 'Moderate',
              },
              { key: 'Medium', text: 'Medium', value: 'Medium' },
              { key: 'High', text: 'High', value: 'High' },
              {
                key: 'Very High',
                text: 'Very High',
                value: 'Very High',
              },
            ],
          },
          {
            texts: 'Wind Of Film Before',
            text: 'Wind Of Film Before',
            value: 'Wind Of Film Before',
            options: [
              { key: 'Tight', text: 'Tight', value: 'Tight' },
              { key: 'Spoked', text: 'Spoked', value: 'Spoked' },
              {
                key: 'Preservation',
                text: 'Preservation',
                value: 'Preservation',
              },
              { key: 'Loose', text: 'Loose', value: 'Loose' },
            ],
          },
          {
            texts: 'Subtitle',
            text: 'Subtitle',
            value: 'Subtitle',
            options: [
              {
                key: 'English',
                text: 'English',
                value: 'English',
              },
              { key: 'French', text: 'French', value: 'French' },
              { key: 'German', text: 'German', value: 'German' },
            ],
          },
          {
            texts: 'Subtitle Languages',
            text: 'Subtitle Languages',
            value: 'Subtitle Languages',
            options: [
              {
                key: 'English',
                text: 'English',
                value: 'English',
              },
              { key: 'French', text: 'French', value: 'French' },
              { key: 'German', text: 'German', value: 'German' },
            ],
          },
          {
            texts: 'Treatment Recommended',
            text: 'Treatment Recommended',
            value: 'Treatment Recommended',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              {
                key: 'Ultrasonic/Manual Clean',
                text: 'Ultrasonic/Manual Clean',
                value: 'Ultrasonic/Manual Clean',
              },
              {
                key: 'Dessication',
                text: 'Dessication',
                value: 'Dessication',
              },
              {
                key: 'Unblocking',
                text: 'Unblocking',
                value: 'Unblocking',
              },
              {
                key: 'Re-hydration/Softening',
                text: 'Re-hydration/Softening',
                value: 'Re-hydration/Softening',
              },
            ],
          },
          {
            texts: 'Shrinkage',
            text: 'Shrinkage',
            value: 'Shrinkage',
            options: [
              { key: '0%', text: '0%', value: '0%' },
              { key: '0-0.7%', text: '0-0.7%', value: '0-0.7%' },
              {
                key: '0.8-1.5%',
                text: '0.8-1.5%',
                value: '0.8-1.5%',
              },
              { key: '1.6-2%', text: '1.6-2%', value: '1.6-2%' },
              { key: '>2%', text: '>2%', value: '>2%' },
            ],
          },
          {
            text: 'Add Photograph',
            value: 'Add Photograph',
            Photography: [
              {
                text: 'Add Photograph',
                value: 'Add Photograph',
                key: 'Add Photograph',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Categorization',
        value: 'Categorization',
        field: [
          {
            texts: 'Categorization using AD strip',
            text: 'Categorization using AD strip',
            value: 'Categorization using AD strip',
            options: [
              {
                key: 'Green pH 3.8',
                text: 'A(Good)',
                value: 'A(Good)',
              },
              {
                key: 'Blue pH 5.4',
                text: 'B(Bad)',
                value: 'B(Bad)',
              },
              {
                key: 'Yellow pH 3.8',
                text: 'C(Worse)',
                value: 'C(Worse)',
              },
            ],
          },
          {
            texts: 'Colour of AD strip with PH Value',
            text: 'Colour of AD strip with PH Value',
            value: 'Colour of AD strip with PH Value',
            options: [
              {
                key: 'Yellow pH 4.0',
                text: 'Yellow pH 4.0',
                value: 'Yellow pH 4.0',
                image:
                  'https://p.kindpng.com/picc/s/128-1289659_green-circle-png-page-green-bubbles-speech-png.png',
              },
              {
                key: 'Green Yellow pH 4.2',
                text: 'Green Yellow pH 4.2',
                value: 'Green Yellow pH 4.2',
                image:
                  'https://p.kindpng.com/picc/s/128-1289659_green-circle-png-page-green-bubbles-speech-png.png',
              },
              {
                key: 'Green pH 4.8',
                text: 'Green pH 4.8',
                value: 'Green pH 4.8',
                image:
                  'https://p.kindpng.com/picc/s/128-1289659_green-circle-png-page-green-bubbles-speech-png.png',
              },
              {
                key: 'Blue Green pH 5.0',
                text: 'Blue Green pH 5.0',
                value: 'Blue Green pH 5.0',
                image:
                  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUjLXYmiU76bODbgkcclpzfOcXcFPwF3wziLXNegTvZUvYMqPAZ4aspMbvYDAzeihWK_M&usqp=CAU',
              },
              {
                key: 'Blue pH 6.0',
                text: 'Blue pH 6.0',
                value: 'Blue pH 6.0',
                image:
                  'https://p.kindpng.com/picc/s/406-4066806_clipart-circle-green-green-circle-image-png-transparent.png',
              },
            ],
          },
          {
            texts: 'Treatment Suggested',
            text: 'Treatment Suggested',
            value: 'Treatment Suggested',
            options: [
              { key: 'None', text: 'None', value: 'None' },
              {
                key: 'Ultrasonic/Manual Clean',
                text: 'Ultrasonic/Manual Clean',
                value: 'Ultrasonic/Manual Clean',
              },
              {
                key: 'Dessication',
                text: 'Dessication',
                value: 'Dessication',
              },
              {
                key: 'Unblocking',
                text: 'Unblocking',
                value: 'Unblocking',
              },
              {
                key: 'Re-hydration/Softening',
                text: 'Re-hydration/Softening',
                value: 'Re-hydration/Softening',
              },
            ],
          },
          {
            texts: 'Final Vault Location',
            text: 'Final Vault Location',
            value: 'Final Vault Location',
            options: [
              { text: 'PCPL', value: 'device1' },
              { text: 'PXD', value: 'device2' },
              { text: 'PP', value: 'device3' },
              { text: 'EFX', value: 'device4' },
              { text: 'PP', value: 'device5' },
              { text: 'PrasadFilmLab', value: 'device6' },
              { text: 'CloudBackup', value: 'device7' },
              { text: 'PrasadFilmLab', value: 'device8' },
              { text: 'CloudBackup', value: 'device9' },
              { text: 'EFX', value: 'device10' },
            ],
          },
          {
            texts: 'Green Sticker',
            text: 'Green Sticker',
            value: 'Green Sticker',
            options: [
              {
                key: 'Building/Type',
                text: 'Building/Type',
                value: 'Building/Type',
              },
              {
                key: 'Red Sticker',
                text: 'Red Sticker',
                value: 'Red Sticker',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Repair',
        value: 'Repair',
        field: [
          {
            texts: 'Repair Type',
            text: 'Repair Type',
            value: 'Repair Type',
            options: [
              { key: 'Minor', text: 'Minor', value: 'Minor' },
              { key: 'Major', text: 'Major', value: 'Major' },
            ],
          },
          {
            texts: 'Type of Joints',
            text: 'Type of Joints',
            value: 'Type of Joints',
            options: [
              { key: 'Tape', text: 'Tape', value: 'Tape' },
              { key: 'Cement', text: 'Cement', value: 'Cement' },
            ],
          },
          {
            texts: 'Leader Type',
            text: 'Leader Type',
            value: 'Leader Type',
            options: [
              {
                key: 'Leader Changed',
                text: 'Leader Changed',
                value: 'Leader Changed',
              },
              {
                key: 'Leader Added',
                text: 'Leader Added',
                value: 'Leader Added',
              },
            ],
          },
          {
            texts: 'Can After',
            text: 'Can After',
            value: 'Can After',
            options: [
              { key: 'Yes', text: 'Yes', value: 'Yes' },
              { key: 'No', text: 'No', value: 'No' },
              {
                key: 'Plastic',
                text: 'Plastic',
                value: 'Plastic',
              },
              {
                key: 'Can Changed',
                text: 'Can Changed',
                value: 'Can Changed',
              },
            ],
          },
          {
            texts: 'Photography Taken After',
            text: 'Photography Taken After',
            value: 'Photography Taken After',
            options: [
              { key: 'Minor', text: 'Minor', value: 'Minor' },
              { key: 'Major', text: 'Major', value: 'Major' },
            ],
          },
          {
            texts: 'History Card Inside Can',
            text: 'History Card Inside Can',
            value: 'History Card Inside Can',
            options: [
              { key: 'Yes', text: 'Yes', value: 'Yes' },
              { key: 'No', text: 'No', value: 'No' },
              { key: 'Qty', text: 'Qty', value: 'Qty' },
            ],
          },
          {
            texts: 'History Card Photograph',
            text: 'History Card Photograph',
            value: 'History Card Photograph',
            options: [
              { key: 'Minor', text: 'Minor', value: 'Minor' },
              { key: 'Major', text: 'Major', value: 'Major' },
            ],
          },
          {
            texts: 'Details of Repair',
            text: 'Details of Repair',
            value: 'Details of Repair',
            options: [
              {
                key: 'No Of Joints Repaired',
                text: 'No Of Joints Repaired',
                value: 'No Of Joints Repaired',
              },
              {
                key: 'No Of Perforation Repaired',
                text: 'No Of Perforation Repaired',
                value: 'No Of Perforation Repaired',
              },
              {
                key: 'No Of Pre Existing Repaired Joints',
                text: 'No Of Pre Existing Repaired Joints',
                value: 'No Of Pre Existing Repaired Joints',
              },
            ],
          },
          {
            texts: 'Core Changed',
            text: 'Core Changed',
            value: 'Core Changed',
            options: [
              {
                key: 'Leader Changed',
                text: 'Leader Changed',
                value: 'Leader Changed',
              },
              {
                key: 'Leader Added',
                text: 'Leader Added',
                value: 'Leader Added',
              },
            ],
          },
          {
            texts: 'Can Changed',
            text: 'Can Changed',
            value: 'Can Changed',
            options: [
              {
                key: 'Leader Changed',
                text: 'Leader Changed',
                value: 'Leader Changed',
              },
              {
                key: 'Leader Added',
                text: 'Leader Added',
                value: 'Leader Added',
              },
            ],
          },
          {
            text: 'Add Photograph',
            value: 'Add Photograph',
            Photography: [
              {
                text: 'Add Photograph',
                value: 'Add Photograph',
                key: 'Add Photograph',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Photo Chemical Restoration',
        value: 'Photo Chemical Restoration',
        field: [
          {
            texts: 'Dessication Treatment',
            text: 'Dessication Treatment',
            value: 'Dessication Treatment',
          },
          {
            texts: 'Rehydration',
            text: 'Rehydration',
            value: 'Rehydration',
          },
          {
            texts: 'Unblocking',
            text: 'Unblocking',
            value: 'Unblocking',
          },
          {
            text: 'Add Photograph',
            value: 'Add Photograph',
            Photography: [
              {
                text: 'Add Photograph',
                value: 'Add Photograph',
                key: 'Add Photograph',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Ultra Sonic Cleaning',
        value: 'Ultra Sonic Cleaning',
        field: [
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
    ],
  },
  {
    name: 'Digitization',
    text: 'Digitization',
    value: 'Digitization',
    Icon: 'film',
    mile: [
      {
        text: 'Specification',
        value: 'Specification',
        field: [
          {
            texts: 'Scan Resolution',
            text: 'Scan Resolution',
            value: 'Scan Resolution',
            options: [
              { key: 'Bob', text: '4K-4096', value: '4K-4096' },
              { key: 'Jane', text: '3112', value: '3112' },
              { key: 'Tom', text: '2K', value: '2K' },
            ],
          },
          {
            texts: 'Aspect Ratio',
            text: 'Aspect Ratio',
            value: 'Aspect Ratio',
            options: [
              { key: 'Bob', text: '4:3 WITH', value: '4:3 WITH' },
              {
                key: 'Jane',
                text: 'WITHOUT SOUND APERTURE	',
                value: 'WITHOUT SOUND APERTURE	',
              },
            ],
          },
          {
            texts: 'Scan Mode',
            text: 'Scan Mode',
            value: 'Scan Mode',
            options: [
              {
                key: 'Bob',
                text: 'Pan and Scan',
                value: 'Pan and Scan',
              },
              {
                key: 'Jane',
                text: 'Letter Box	',
                value: 'Letter Box	',
              },
              {
                key: 'Jane',
                text: 'Pillar Box	',
                value: 'Pillar Box	',
              },
              {
                key: 'Jane',
                text: 'Full Frame	',
                value: 'Full Frame	',
              },
              {
                key: 'Jane',
                text: 'Over Scan	',
                value: 'Over Scan	',
              },
            ],
          },
          {
            texts: 'File Format',
            text: 'File Format',
            value: 'File Format',
            options: [
              { key: 'Bob', text: 'DPX	', value: 'DPX	' },
              { key: 'Jane', text: ' Tiff		', value: ' Tiff		' },
            ],
          },
          {
            texts: 'Bit Depth',
            text: 'Bit Depth',
            value: 'Bit Depth',
            options: [
              { key: 'Bob', text: '16 bit	', value: '16 bit	' },
              {
                key: 'Jane',
                text: '  10 bit -  Log or linear		',
                value: '  10 bit -  Log or linear		',
              },
            ],
          },
          {
            texts: 'Color Mode',
            text: 'Color Mode',
            value: 'Color Mode',
            options: [
              { key: 'Bob', text: 'RGB', value: 'RGB' },
              {
                key: 'Jane',
                text: '  Monochrome	',
                value: '  Monochrome	',
              },
            ],
          },
          {
            texts: 'Gate',
            text: 'Gate',
            value: 'Gate',
            options: [
              { key: 'Bob', text: 'Wet Gate', value: 'Wet Gate' },
              {
                key: 'Jane',
                text: 'Dry Gate	',
                value: 'Dry Gate	',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Digitization',
        value: 'Digitization',
        field: [
          {
            texts: 'Scanning Technician Comments',
            text: 'Scanning Technician Comments',
            value: 'Scanning Technician Comments',
          },
        ],
      },
      {
        text: 'Quality Check',
        value: 'Quality Check',
        field: [
          {
            texts: 'QC technician Comments',
            text: 'QC technician Comments',
            value: 'QC technician Comments',
          },
        ],
      },
      {
        text: 'Deliverables',
        value: 'Deliverables',
        field: [
          {
            texts: 'File type',
            text: 'File type',
            value: 'File type',
            options: [
              { key: 'Bob', text: 'DPX', value: 'DPX ' },
              { key: 'Jane', text: '   Tiff	', value: '   Tiff	' },
              {
                key: 'Jane',
                text: '  Prores	',
                value: '  Prores	',
              },
              { key: 'Jane', text: '  Mov	', value: '  Mov	' },
              { key: 'Jane', text: '  etc	', value: '  etc	' },
            ],
          },
          {
            texts: 'Media',
            text: 'Media',
            value: 'Media',
            options: [
              { key: 'Bob', text: 'HDD ', value: 'HDD  ' },
              { key: 'Jane', text: '   LTO	', value: '   LTO	' },
              {
                key: 'Jane',
                text: '  Upload	',
                value: '  Upload	',
              },
            ],
          },
          {
            texts: 'Label for Backup Media',
            text: 'Label for Backup Media',
            value: 'Label for Backup Media',
          },
        ],
      },
    ],
  },
  {
    name: 'Restoration',
    text: 'Restoration',
    value: 'Restoration',
    Icon: 'video',
    mile: [
      {
        text: 'Basic Specification from CS',
        value: 'Basic Specification from CS',
        field: [
          {
            texts: 'Resolution',
            text: 'Resolution',
            value: 'Resolution',
          },
          {
            texts: 'QC Process',
            text: 'QC Process',
            value: 'QC Process',
            options: [
              { key: 'Bob', text: '6 FPS', value: '6 FPS ' },
              {
                key: 'Jane',
                text: '   12 FPS	',
                value: '    12 FPS	',
              },
              {
                key: 'Jane',
                text: '  24 FPS 	',
                value: '  24 FPS 	',
              },
            ],
          },
          {
            texts: 'Title',
            text: 'Title',
            value: 'Title',
          },
          {
            texts: 'Client',
            text: 'Client',
            value: 'Client',
          },
          {
            texts: 'Revenue',
            text: 'Revenue',
            value: 'Revenue',
          },
          {
            texts: 'Effort Hours',
            text: 'Effort Hours',
            value: 'Effort Hours',
          },
          {
            texts: 'Sample Approved',
            text: 'Sample Approved',
            value: 'Sample Approved',
            options: [
              {
                key: 'Leader Changed',
                text: 'Leader Changed',
                value: 'Leader Changed',
              },
              {
                key: 'Leader Added',
                text: 'Leader Added',
                value: 'Leader Added',
              },
            ],
          },
          {
            texts: 'Delivery Deadline',
            text: 'Delivery Deadline',
            value: 'Delivery Deadline',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Sample',
        value: 'Sample',
        field: [
          {
            texts: 'Input',
            text: 'Input',
            value: 'Input',
            options: [{ key: 'Bob', text: 'Revenue', value: 'Revenue ' }],
          },
          {
            texts: 'QC type',
            text: 'QC type',
            value: 'QC type',
            options: [
              { key: 'Bob', text: '6 FPS', value: '6 FPS ' },
              {
                key: 'Jane',
                text: '   12 FPS	',
                value: '    12 FPS	',
              },
              {
                key: 'Jane',
                text: '  24 FPS 	',
                value: '  24 FPS 	',
              },
            ],
          },
          {
            texts: 'Sample  Start Date',
            text: 'Sample  Start Date',
            value: 'Sample Start Date',
          },
          {
            texts: 'Sample  End Date',
            text: 'Sample  End Date',
            value: 'Sample End Date',
          },
          {
            texts: 'Sample done by',
            text: 'Sample done by',
            value: 'Sample done by',
          },
          {
            texts: 'Shot Type',
            text: 'Shot Type',
            value: 'Shot Type',
            options: [
              { key: 'Bob', text: 'Simple', value: 'Simple ' },
              {
                key: 'Jane',
                text: '   Medium',
                value: '  Medium',
              },
              {
                key: 'Jane',
                text: '  Complex',
                value: '  Complex	',
              },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Sample QC',
        value: 'Sample QC',
        field: [
          {
            texts: 'QC Done by',
            text: 'QC Done by',
            value: 'QC Done by',
          },
          {
            texts: 'Sample Approval by Client',
            text: 'Sample Approval by Client',
            value: 'Sample Approval by Client',
            options: [
              { key: 'Bob', text: 'Yes ', value: 'Yes  ' },
              { key: 'Jane', text: '   No', value: '   No	' },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Analysis',
        value: 'Analysis',
        field: [
          {
            texts: 'Analysis done by',
            text: 'Analysis done by',
            value: 'Analysis done by',
          },
          {
            texts: 'Detailed Analysis report',
            text: 'Detailed Analysis report',
            value: 'Detailed Analysis report',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Estimation',
        value: 'Estimation',
        field: [
          {
            texts: 'Estimation Done by',
            text: 'Estimation Done by',
            value: 'Estimation Done by',
          },
          {
            texts: 'Estimated Hours',
            text: 'Estimated Hours',
            value: 'Estimated Hours',
          },
          {
            texts: 'Total Frames Estimated',
            text: 'Total Frames Estimated',
            value: 'Total Frames Estimated',
          },
          {
            texts: 'Estimation Report',
            text: 'Estimation Report',
            value: 'Estimation Report',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Production',
        value: 'Production',
        field: [
          {
            texts: 'Effort hours provided for Production',
            text: 'Effort hours provided for Production',
            value: 'Effort hours provided for Production',
          },
          {
            texts: 'Path for Approved Sample',
            text: 'Path for Approved Sample',
            value: 'Path for Approved Sample',
          },
          {
            texts: 'Title Code  ( Autogenerated )',
            text: 'Title Code  ( Autogenerated )',
            value: 'Title Code  ( Autogenerated )',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Team Allocation',
        value: 'Team Allocation',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Cutlist upload',
        value: 'Cutlist upload',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Specification by Tech team',
        value: 'Specification by Tech team',
        field: [
          {
            texts: 'Dust threshold',
            text: 'Dust threshold',
            value: 'Dust threshold',
          },
          {
            texts: 'Grain  comments',
            text: 'Grain  comments',
            value: 'Grain comments',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Allocation',
        value: 'Allocation',
        field: [
          {
            texts: 'Team wise / Operator wise',
            text: 'Team wise / Operator wise',
            value: 'Team wise / Operator wise',
          },
          {
            texts: 'Submission for QC',
            text: 'Submission for QC',
            value: 'Submission for QC',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'QC',
        value: 'QC',
        field: [
          {
            texts: 'Approved / Rejected',
            text: 'Approved / Rejected',
            value: 'Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'QA',
        value: 'QA',
        field: [
          {
            texts: 'Quality Check - Approved / Rejected',
            text: 'Quality Check - Approved / Rejected',
            value: 'Quality Check - Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Final QA',
        value: 'Final QA',
        field: [
          {
            texts: 'Approved / Rejected',
            text: 'Approved / Rejected',
            value: 'Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Wave form Check',
        value: 'Wave form Check',
        field: [
          {
            texts: 'Approved / Rejected ',
            text: 'Approved / Rejected',
            value: 'Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Confidence Check',
        value: 'Confidence Check',
        field: [
          {
            texts: 'Approved / Rejected',
            text: 'Approved / Rejected',
            value: 'Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'MD5 Check Sum',
        value: 'MD5 Check Sum',
        field: [
          {
            texts: 'Approved / Rejected',
            text: 'Approved / Rejected',
            value: 'Approved / Rejected',
          },
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Final Restoration Report',
        value: 'Final Restoration Report',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Output Delivery',
        value: 'Output Delivery',
        field: [
          {
            texts: 'File type',
            text: 'File type',
            value: 'File type',
            options: [
              { key: 'Bob', text: 'DPX', value: 'DPX ' },
              { key: 'Jane', text: '   Tiff	', value: '   Tiff	' },
              {
                key: 'Jane',
                text: '  Prores	',
                value: '  Prores	',
              },
              { key: 'Jane', text: '  Mov	', value: '  Mov	' },
              { key: 'Jane', text: '  etc	', value: '  etc	' },
            ],
          },
          {
            texts: 'Media',
            text: 'Media',
            value: 'Media',
            options: [
              { key: 'Bob', text: 'HDD ', value: 'HDD  ' },
              { key: 'Jane', text: '   LTO	', value: '   LTO	' },
              {
                key: 'Jane',
                text: '  Upload	',
                value: '  Upload	',
              },
            ],
          },
        ],
      },
      {
        text: 'Project closure report',
        value: 'Project closure report',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Client rejection Feedback',
        value: 'Client rejection Feedback',
        field: [
          {
            texts: 'Rework',
            text: 'Rework',
            value: 'Rework',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Final Approval',
        value: 'Final Approval',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Purge',
        value: 'Purge',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
    ],
  },
  {
    name: 'Review',
    text: 'Review',
    value: 'Review',
    Icon: 'check',
    mile: [
      {
        text: 'Option 1',
        value: 'Option 1',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
      {
        text: 'Option 2',
        value: 'Option 2',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
      {
        text: 'Option 3',
        value: 'Option 3',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
    ],
  },
  {
    name: 'Archive',
    text: 'Archive',
    value: 'Archive',
    Icon: 'archive',
    mile: [
      {
        text: 'Picker Assign',
        value: 'Picker Assign',
        field: [
          {
            texts: 'Names',
            text: 'Names',
            value: 'Names',
            options: [
              { key: 'Bob', text: 'Bob', value: 'Bob' },
              { key: 'Jane', text: 'Jane', value: 'Jane' },
              { key: 'Tom', text: 'Tom', value: 'Tom' },
              { key: 'Rujula', text: 'Rujula', value: 'Rujula' },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Move to Vault',
        value: 'Move to Vault',
        field: [
          {
            texts: 'QR Code',
            text: 'QR Code',
            value: 'QR Code',
          },
          {
            texts: 'RFID',
            text: 'RFID',
            value: 'RFID',
          },
          {
            texts: 'Barcode',
            text: 'Barcode',
            value: 'Barcode',
          },
          {
            texts: 'Select Shelf',
            text: 'Select Shelf',
            value: 'Select Shelf',
            options: [
              { text: 'PCPL/V01', value: 'Vault1' },
              { text: 'PCPL/V02', value: 'Vault2' },
              { text: 'PXD/V01', value: 'Vault3' },
              { text: 'PXD/V02', value: 'Vault4' },
              { text: 'PP/V01', value: 'Vault5' },
              { text: 'PP/V02', value: 'Vault6' },
              { text: 'EFX/V01', value: 'Vault7' },
              { text: 'EFX/V02', value: 'Vault8' },
              { text: 'PrasadFilmLab/V01', value: 'Vault9' },
              { text: 'PrasadFilmLab/V02', value: 'Vault10' },
              { text: 'CloudBackup/V01', value: 'Vault11' },
              { text: 'CloudBackup/V02', value: 'Vault12' },
              { text: 'ForeignVault/V01', value: 'Vault13' },
              { text: 'ForeignVault/V02', value: 'Vault14' },
              { text: 'ForeignVault/V03', value: 'Vault15' },
            ],
          },
          {
            texts: 'Select Vault Name',
            text: 'Select Vault Name',
            value: 'Select Vault Name',
            options: [
              { text: 'PCPL', value: 'device1' },
              { text: 'PXD', value: 'device2' },
              { text: 'PP', value: 'device3' },
              { text: 'EFX', value: 'device4' },
              { text: 'PP', value: 'device5' },
              { text: 'PrasadFilmLab', value: 'device6' },
              { text: 'CloudBackup', value: 'device7' },
              { text: 'PrasadFilmLab', value: 'device8' },
              { text: 'CloudBackup', value: 'device9' },
              { text: 'EFX', value: 'device10' },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
    ],
  },
  {
    name: 'Access',
    text: 'Access',
    value: 'Access',
    Icon: 'globe',
    mile: [
      {
        text: 'Assign Picker',
        value: 'Assign Picker',
        field: [
          {
            texts: 'Names',
            text: 'Names',
            value: 'Names',
            options: [
              { key: 'Bob', text: 'Bob', value: 'Bob' },
              { key: 'Jane', text: 'Jane', value: 'Jane' },
              { key: 'Tom', text: 'Tom', value: 'Tom' },
              { key: 'Rujula', text: 'Rujula', value: 'Rujula' },
            ],
          },
          {
            texts: 'Comments',
            text: 'Comments',
            value: 'Comments',
          },
        ],
      },
      {
        text: 'Move to Climatisation',
        value: 'Move to Climatisation',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
      {
        text: 'Ready for outward deliver',
        value: 'Ready for outward deliver',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
      {
        text: 'Delivered',
        value: 'Delivered',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
      {
        text: 'Returned',
        value: 'Returned',
        field: [
          {
            texts: 'Option 1',
            text: 'Option 1',
            value: 'Option 1',
          },
          {
            texts: 'Option 2',
            text: 'Option 2',
            value: 'Option 2',
          },
          {
            texts: 'Option 3',
            text: 'Option 3',
            value: 'Option 3',
          },
        ],
      },
    ],
  },
];
